import { IOptionItem } from '~/models/common';
import { AdminOptionTabs } from '~/models/adminOptions';
import { transformTypeOptions } from '~/utils/common';
import { IOrg } from '~/models/org';
import { IUser } from '~/models/user';
import { TutorialData } from './tutorial';

export const TIMEZONE_SETTING = {
  AUTO_DETECT: 'auto',
  MANUALLY: 'manual',
};

export const GENERAL_SETTING_DEFAULT: IUser = {
  id: '',
  items_per_page: 25,
  timezone: 'auto',
  timezoneType: '',
  first_name: '',
  last_name: '',
  avatar: '',
  profile_photo: '',
  notification_setting: {
    url: 'https://storage.googleapis.com/int-chatso-media/chatso-v2/audio-notification/default/v2/Default.aac',
    repeatingInterval: '0',
    mute: false,
    task_update: {
      enable: true,
      duration: 0,
    },
    import_csv: {
      enable: true,
      duration: 0,
    },
    new_driver: {
      enable: true,
      duration: 0,
    },
  },
};

export const ORGANIZATION_DEFAULT: IOrg = {
  name: '',
  auto_assign: false,
};

export const ADMIN_OPTIONS_OPTIONS: IOptionItem[] =
  transformTypeOptions(AdminOptionTabs);

export const AdminOptionTutorial = {
  organization: TutorialData.Organization,
  stores: TutorialData.Stores,
  drivers: TutorialData.Drivers,
  teams: TutorialData.Teams,
  users: TutorialData.Users,
};
